export class EsportsTeam {
  _id?: string;
  name: string = '';
  image: string = '';
  background: string = '';
  title: string = '';
  description: string = '';
  url: string = '';
  position: number = 0;
  active: boolean = false;
  created: Date;
  updated: Date;
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-teams/shared/esports-team.model.ts